import React from 'react';

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Section A 顶部介绍 */}
      <section className="bg-gradient-to-r from-blue-200 via-purple-200 to-pink-100 pt-36 pb-24 mt-16">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4 text-blue-800">关于我们</h1>
        </div>
      </section>
      {/* Section B 认识我们 */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex flex-col items-center gap-8">
            <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714213710_30pQNl.jpg" alt="创始人" className="w-48 h-48 object-cover rounded-full shadow mb-2" />
            <div className="text-2xl font-bold text-gray-800 mb-2">汪县军</div>
            <div className="text-gray-700 text-center leading-relaxed">
              祁门县服装产业园董事长<br/>
              图兰朵服饰有限公司总经理<br/>
              探木登户外用品有限公司总经理<br/>
              祁门县瑞园外国语学校董事长<br/>
              祁门县第十二届政协委员<br/>
              祁门县驻杭州招商小组常务副组长
            </div>
          </div>
        </div>
      </section>

      {/* 居中展示图片的新section */}
      {/* <section className="py-12">
        <div className="max-w-3xl mx-auto px-4 flex justify-center">
          <img src="/images/about-center.jpg" alt="关于我们配图" className="rounded-xl shadow max-w-full h-auto" />
        </div>
      </section> */}

      {/* Section C 服装加工园区 */}
      {/* <section className="py-16 bg-blue-50">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8">
          <div className="w-full md:w-[70%]">
            <img src="/images/park-garment.jpg" alt="服装加工园区" className="rounded-xl shadow w-full aspect-video object-cover" />
          </div>
          <div className="w-full md:w-[30%] flex flex-col items-start md:pl-8 mt-6 md:mt-0">
            <h3 className="text-2xl font-bold mb-4 text-gray-800">服装加工园区</h3>
          </div>
        </div>
      </section> */}

      {/* Section D 电商物流园区 */}
      {/* <section className="py-16 bg-green-50">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8">
          <div className="w-full md:w-[30%] flex flex-col items-start md:pr-8 mb-6 md:mb-0">
            <h3 className="text-2xl font-bold mb-4 text-gray-800">电商物流园区</h3>
          </div>
          <div className="w-full md:w-[70%]">
            <img src="/images/park-logistics.jpg" alt="电商物流园区" className="rounded-xl shadow w-full aspect-video object-cover" />
          </div>
        </div>
      </section> */}

      {/* Section E 户外装备园区 */}
      {/* <section className="py-16 bg-yellow-50">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8">
          <div className="w-full md:w-[70%]">
            <img src="/images/park-outdoor.jpg" alt="户外装备园区" className="rounded-xl shadow w-full aspect-video object-cover" />
          </div>
          <div className="w-full md:w-[30%] flex flex-col items-start md:pl-8 mt-6 md:mt-0">
            <h3 className="text-2xl font-bold mb-4 text-gray-800">户外装备园区</h3>
          </div>
        </div>
      </section> */}

      {/* Section F 荣誉证书 */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">荣誉证书</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/png/20250714162912_L8KVVT.png" alt="荣誉证书1" className="rounded-xl shadow w-full aspect-[4/3] object-cover" />
            <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/png/20250714162826_xE4rWo.png" alt="荣誉证书2" className="rounded-xl shadow w-full aspect-[4/3] object-cover" />
            <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/png/20250714162932_JJZFT4.png" alt="荣誉证书3" className="rounded-xl shadow w-full aspect-[4/3] object-cover" />
            <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/png/20250714162959_xgzL2O.png" alt="荣誉证书4" className="rounded-xl shadow w-full aspect-[4/3] object-cover" />
            <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/png/20250714163026_ZSwb2Y.png" alt="荣誉证书5" className="rounded-xl shadow w-full aspect-[4/3] object-cover" />
            <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/png/20250714163055_aTT8hh.png" alt="荣誉证书6" className="rounded-xl shadow w-full aspect-[4/3] object-cover" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 